<template>
  <form v-on:submit.prevent.stop="submit">
    <data-entry-field v-for="(item, index) in availableItems" :key="index" :item="item" ref="fieldComponents" v-on:check-change="checkChange"></data-entry-field>
    <b-alert variant="danger" :show="!isValid">{{errorMessage}}</b-alert>
    <button type="submit" style="display:none">Submit</button>
  </form>
</template>


<script>
import DataEntryField from '@/components/data_entry/DataEntryField'
import _ from 'lodash'

export default {
  name: 'DataEntryForm',
  components: {
    'data-entry-field': DataEntryField
  },
  props: {
    fields: { type: Array }
  },
  data () {
    var checkFields = {}
    var items = this.fields.map((field) => { return this.itemForField(field, checkFields) })
    return {
      items: items,
      checkFields: checkFields,
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {
    availableItems () {
      return this.items.filter((item) => item.field.entry_type !== 'images' && item.field.entry_type !== 'videos')
    }
  },
  methods: {
    itemForField (field, checkFields) {
      var items = []
      if (field.data_entry_items != null && field.data_entry_items.length > 0) {
        items = field.data_entry_items.map((item) => { return this.itemForField(item, checkFields) })
      }
      var item = {
        value: field.value || '',
        disabled: false,
        field: field,
        items: items
      }
      if (field.entry_type === 'check') {
        item.value = false
        if (!_.has(checkFields, item.field.field_name)) {
          checkFields[item.field.field_name] = {}
        }
        checkFields[item.field.field_name][item.field.check_value] = item
      }
      return item
    },
    checkChange (details, event) {
      const fieldName = details.fieldName
      var checks = this.checkFields[fieldName]
      var validCheckValues = new Set()
      _.keys(checks).forEach((checkValue) => {
        validCheckValues.add(checkValue)
      })
      _.values(checks).forEach((check) => {
        if (check.value && check.field.compatible_values != null) {
          validCheckValues.forEach((value) => {
            if (check.field.compatible_values.indexOf(value) === -1 && check.field.check_value !== value) {
              validCheckValues.delete(value)
            }
          })
        }
      })
      _.values(checks).forEach((check) => {
        check.disabled = !(validCheckValues.has(check.field.check_value))
        if (check.disabled) {
          check.value = false
        }
      })
    },
    validate () {
      this.isValid = true
      if (this.$refs.fieldComponents != null) {
        this.$refs.fieldComponents.forEach((field) => { this.isValid = field.validate() && this.isValid })
      }
      if (!this.isValid) {
        this.errorMessage = 'Please enter the requested information'
      } else {
        _.values(this.checkFields).forEach((checks) => {
          var isMandatory = false
          var anyChecked = false
          _.values(checks).forEach((check) => {
            isMandatory = check.field.mandatory || isMandatory
            anyChecked = check.value || anyChecked
          })
          if (isMandatory && !anyChecked) {
            this.isValid = false
            this.errorMessage = 'Please select at least one option'
          }
        })
      }
      return this.isValid
    },
    values () {
      var values = []
      if (this.$refs.fieldComponents != null) {
        this.$refs.fieldComponents.forEach((field) => { values = _.concat(values, field.values()) })
      }
      return _.compact(values)
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>
<style>
.custom-control-input:disabled~.custom-control-label,
.form-group.disabled label,
.form-group.disabled .custom-control-input:disabled~.custom-control-label {
    color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/DataEntryForm.vue